import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
// Change the paths to import translations
import enTranslation from './locales/en.json';
import thTranslation from './locales/th.json';
import loTranslation from './locales/lo.json';
import viTranslation from './locales/vi.json';
import zhTranslation from './locales/zh.json';
import kmTranslation from './locales/km.json';
import myTranslation from './locales/my.json';
import idTranslation from './locales/id.json';


const resources = {
  en: { translation: enTranslation },
  th: { translation: thTranslation },
  lo: { translation: loTranslation },
  vi: { translation: viTranslation },
  zh: { translation: zhTranslation },
  km: { translation: kmTranslation },
  my: { translation: myTranslation },
  id: { translation: idTranslation },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'lo', // default language
  fallbackLng: 'lo',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
